export const FISHYMAP_SIGNALS_READY_EVENT = "fishymap:signals-ready";
export const FISHYMAP_SIGNALS_READY_ATTRIBUTE = "data-fishymap-signals-ready";

export function resolveMapPageShell(globalRef = globalThis) {
  const shell = globalRef.document?.getElementById?.("map-page-shell");
  return shell && typeof shell.dispatchEvent === "function" ? shell : null;
}

export function mapShellSignalsAreReady(shell) {
  if (!shell || typeof shell.getAttribute !== "function") {
    return false;
  }
  return shell.getAttribute(FISHYMAP_SIGNALS_READY_ATTRIBUTE) === "true";
}
